import * as React from 'react';
import { Redirect, Link } from 'react-router-dom';
import Loader from '../shared/loader';

export class SetPassword extends React.Component<
  {
    isLoggedIn: boolean;
    user;
    shouldPasswordBeSet;
    isPasswordSet;
    checkPassword;
    location;
    disablePassword;
    initial;
  },
  { password: string }
> {
  constructor(props) {
    super(props);
    this.state = { password: '' };

    this.submit = this.submit.bind(this);
    this.skip = this.skip.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  submit(event) {
    event.stopPropagation();
    event.preventDefault();
    this.props.checkPassword(this.state.password);
  }

  skip(event) {
    event.stopPropagation();
    event.preventDefault();
    this.props.disablePassword();
  }

  handleChange({ target: { value: password } }) {
    this.setState({
      password
    });
  }

  render() {
    let originalLocation = JSON.parse(sessionStorage.getItem('redirect') || '""') || '/dashboard';
    const { initial, isLoggedIn, user, shouldPasswordBeSet, isPasswordSet } = this.props;
    const { location: { state: { from = originalLocation } = {} } = {} } = this.props;

    if (initial) {
      return <Loader />;
    }

    if (!shouldPasswordBeSet || isPasswordSet) {
      return <Redirect to={from} />;
    }

    return (
      <form onSubmit={this.submit}>
        <br />
        {!user.hasPassword && (
          <div className="row">
            <div className="col s2">&nbsp;</div>
            <div className="col s8">
              <span>
                Create a password if you want to encrypt your data.
                <Link to="/learn-more">
                  <i className="material-icons" title="learn more">
                    info_outline
                  </i>
                </Link>
              </span>
            </div>
            <button
              type="button"
              onClick={this.skip}
              className="btn-floating waves-effect waves-light light-blue darken-3"
            >
              Skip
            </button>
          </div>
        )}

        <div className="row valign-wrapper">
          <div className="col s2">&nbsp;</div>
          <div className="input-field col s8">
            <input
              type="password"
              className="validate"
              name="password"
              value={this.state.password}
              required
              onChange={this.handleChange}
            />
            <label>Password</label>
          </div>
          <div className="col s2">&nbsp;</div>
        </div>
        <div className="fixed-action-btn">
          <div className="center-align">
            <button type="submit" className="btn-floating btn-large waves-effect waves-light light-blue darken-3">
              <i className="material-icons">done</i>
            </button>
          </div>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/set-password/component.tsx